import * as React from "react";
import { StepOverviewContainer } from "./StepOverviewContainer.js";
const StepOverview = (props) => /* @__PURE__ */ React.createElement(StepOverviewContainer, { ...props });
export {
  StepOverview
};
//# sourceMappingURL=layout.js.map
